import { getWebApp } from './webapp';

/**
 * Тема и геометрия вьюпорта.
 *
 * Цвета Telegram выставляет сам (`--tg-theme-*` на <html>) — их мы не
 * копируем, они читаются прямо из семантических токенов. Здесь ставится
 * только то, чего клиент не даёт CSS-ом: активная тема отдельным атрибутом,
 * платформа, высота и безопасные отступы.
 */
export type ColorScheme = 'light' | 'dark';

const DEFAULT_SCHEME: ColorScheme = 'dark';

export function syncViewportVars(): void {
  const webApp = getWebApp();
  const root = document.documentElement;

  if (!webApp) {
    // Вне Telegram атрибут не ставим: пусть работает системная тема
    root.style.setProperty('--app-viewport-height', '100dvh');
    return;
  }

  root.dataset.theme = webApp.colorScheme;
  root.dataset.tgPlatform = webApp.platform;

  root.style.setProperty(
    '--app-viewport-height',
    `${String(webApp.viewportStableHeight)}px`,
  );

  if (webApp.isVersionAtLeast('8.0')) {
    const inset = webApp.safeAreaInset;
    const content = webApp.contentSafeAreaInset;
    root.style.setProperty(
      '--app-safe-top',
      `${String(inset.top + content.top)}px`,
    );
    root.style.setProperty(
      '--app-safe-bottom',
      `${String(inset.bottom + content.bottom)}px`,
    );
  }
}

/** Подписывает синхронизацию на события клиента. Возвращает отписку. */
export function watchViewport(): () => void {
  const webApp = getWebApp();
  syncViewportVars();

  if (!webApp) return () => undefined;

  webApp.onEvent('viewportChanged', syncViewportVars);
  webApp.onEvent('themeChanged', syncViewportVars);
  webApp.onEvent('safeAreaChanged', syncViewportVars);

  return () => {
    webApp.offEvent('viewportChanged', syncViewportVars);
    webApp.offEvent('themeChanged', syncViewportVars);
    webApp.offEvent('safeAreaChanged', syncViewportVars);
  };
}

/** Текущая тема — для кода, которому нужен не CSS, а значение. */
export function getColorScheme(): ColorScheme {
  return getWebApp()?.colorScheme ?? DEFAULT_SCHEME;
}
